import React from "react";
import Dashboard from "./Pages/EmployeeDashboard/dashboard";
import Personal from "./Pages/EmployeeDashboard/Personal/Personal";
import Job from "./Pages/EmployeeDashboard/Job/Job";
import Emergency from "./Pages/EmployeeDashboard/Emergency/Emergency";
import Documents from "./Pages/EmployeeDashboard/Documents/Documents";
import Assets from "./Pages/EmployeeDashboard/EmployeeAssets/EmployeeAssets";
import Attendance from "./Pages/EmployeeDashboard/EmployeeAttendence/EmployeeAttendence";
import Complaints from "./Pages/EmployeeDashboard/Complaints/Complaints";
import ExpenseManagement from "./Pages/EmployeeDashboard/ExpenseManagment/index";
import Compliance from "./Pages/EmployeeDashboard/Compliance/Compliance";
import { BarChartOutlined, CarryOutOutlined, DashboardOutlined, ExclamationCircleOutlined, FileTextOutlined, FolderOpenOutlined, IdcardOutlined, ReadOutlined, SafetyCertificateOutlined, TeamOutlined, ToolOutlined, UsergroupDeleteOutlined, UserOutlined } from "@ant-design/icons";
import LeaveRequest from "./Pages/EmployeeDashboard/LeaveRequest/LeaveRequest";
import TrainingAndDevelopment from "./Pages/EmployeeDashboard/TrainingAndDevelopement/TrainingAndDevelopement";
import ExpenseManagementList from "./Pages/EmployeeDashboard/ManageExpenses/ExpenseManagment";
import EmployeePerformanceReview from "./Pages/EmployeeDashboard/PerformanceReview/EmployeePerformanceRvw";
import Employees from "./Pages/EmployeeDashboard/Employees/Employees";

const routes = [
  {
    type: "collapse", // Use "route" instead of "collapse" for individual routes
    name: "Dashboard",
    key: "Employeedashboard",
    route: "/employeedashboard",
    icon: <DashboardOutlined size="16px" />,
    component: <Dashboard />, // Just reference the component, not JSX
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Personal",
    key: "personal",
    route: "/employeedashboard/personal",
    icon: <UserOutlined size="16px" />,
    component: <Personal />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Job",
    key: "jobemployee",
    route: "/employeedashboard/jobemployee",
    icon: <IdcardOutlined size="12px" />,
    component: <Job />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Compliance",
    key: "compliance",
    route: "/employeedashboard/compliance",
    icon: <SafetyCertificateOutlined size="12px" />,
    component: <Compliance />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Remote Attendance",
    key: "attendance",
    route: "/employeedashboard/attendance",
    icon: <CarryOutOutlined size="12px" />,
    component: <Attendance />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Leave Request",
    key: "leaverequest",
    route: "/employeedashboard/leave-request",
    icon: <FileTextOutlined size="12px" />,
    component: <LeaveRequest />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training",
    key: "training",
    route: "/employeedashboard/training",
    icon: <ReadOutlined size="12px" />,
    component: <TrainingAndDevelopment />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    route: "/employeedashboard/documents",
    icon: <FolderOpenOutlined size="12px" />,
    component: <Documents />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Emergency",
    key: "emergency",
    route: "/employeedashboard/emergency",
    icon: <ExclamationCircleOutlined size="12px" />,
    component: <Emergency />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Assets",
    key: "assets",
    route: "/employeedashboard/assets",
    icon: <ToolOutlined size="12px" />,
    component: <Assets />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Complaints",
    key: "complaints",
    route: "/employeedashboard/complaints",
    icon: <ExclamationCircleOutlined  size="12px" />,
    component: <Complaints />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "My Expenses",
    key: "expenseManagement",
    route: "/employeedashboard/expenseManagement",
    icon: <BarChartOutlined size="12px" />,
    component: <ExpenseManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Employees",
    key: "employees",
    route: "/employeedashboard/employees",
    icon: <TeamOutlined size="12px" />,
    component: <Employees />,
    noCollapse: true,
  },
  {
    type: "divider",
    key: "bottom-divider"
  },
  {
    type: "collapse",
    name: "Performance Review",
    key: "performance-review",
    route: "/employeedashboard/performance-review",
    icon: <TeamOutlined size="12px" />,
    component: <EmployeePerformanceReview/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Manage Expenses",
    key: "manage-expenses",
    route: "/employeedashboard/manage-expenses",
    icon: <BarChartOutlined  size="12px" />,
    component: <ExpenseManagementList />,
    noCollapse: true,
  },
  
    


];

export default routes;
